export default function ImageSourceDirective(module) {
    angular.module(module || 'app')
        .directive('imageSource', imageSource);

    var id = 0;
    imageSource.$inject = ['helper', '$window', '$parse', '$q', '$timeout'];
    function imageSource(helper, $window, $parse, $q, $timeout) {
        var directive = {
            priority: 99,
            restrict: 'A',
            link: link
        };
        return directive;

        function link($scope, $element, $attrs, carousel) {
            var directiveId = id;
            id++;
            var expression;
            var settings = $parse($attrs.imageSource)($scope);
            var queries = helper.getMediaQueries();
            var url;
            var win = angular.element(module === 'umbraco' ? '.umb-editor-container' : $window);
            var deferred = $q.defer();
            var cancelListener = $scope.$on('carouselV2.updated', checkPosition);
            deferred.promise.then(cancelListener);
            var placeholder = angular.element('<div class="image-placeholder"><div class="loading-icon fa fa-gear fa-spin"></div></div>');
            var placeholderImage = placeholder.find('img');
            var positioned = false;
            if ($element.height() > 30) {
                positioned = true;
                placeholderImage.css({
                    top: -$element.outerHeight() / 2 - 17
                });
            }
            if ($element.is('img')) {
                $element.after(placeholder);
            }
            else {
                $element.append(placeholder);
            }

            function setSource() {
                deferred.promise.then(function () {
                    if (!url) {
                        $element.addClass('loaded no-image');
                        placeholder.remove();
                    }
                    else {
                        $element.removeClass('loaded');
                        var image = new Image();
                        image.onload = image.onerror = function () {
                            if (typeof $scope.onloadCallback === "function") {
                                $scope.onloadCallback();
                            }

                            $element.addClass('loaded');
                            if (!positioned) {
                                positioned = true;
                                placeholderImage.css({
                                    position: 'absolute',
                                    top: -$element.outerHeight() / 2 - 17
                                });
                            }
                            placeholder.remove();
                            $scope.$emit('updateSlantedBackground');
                        };
                        image.src = url;
                        if ($element.is('img')) {
                            $element.attr('src', url);
                        }
                        else {
                            $element.css('backgroundImage', "url('" + url + "')");
                        }
                    }
                    scroller.off('scroll.imageSource' + directiveId);
                });
            }

            function checkPosition() {
                var rect = $element[0].getBoundingClientRect();
                if (rect.top <= win.height() * 1.5 && rect.left <= win.width() * 1.5 && rect.bottom <= win.height() * 1.5 + rect.height && rect.right >= -win.width() * .5) {
                    deferred.resolve();
                }
            }

            var scroller = win.on('scroll.imageSource' + directiveId, checkPosition);
            var previousSize;

            //var offsets = scroller[0].getBoundingClientRect();
            if (!settings || typeof (settings) === 'string') {
                url = settings;
                setSource();
            }
            else {
                var retina = $window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)');
                function getUrl() {
                    var keys = Object.keys(queries);
                    var result;
                    for (var i = 0; i < keys.length; i++) {
                        var key = keys[i];
                        if (key.indexOf("down") === -1 && key.indexOf("up") === -1 && key.indexOf("only") === -1) {
                            if (queries[key].matches) {
                                if (settings[key]) {
                                    result = key;
                                }
                            }
                            else {
                                break;
                            }
                        }
                    }
                    if (result) {
                        if (retina.matches && settings[result + 'retina']) {
                            result = result + 'retina';
                        }
                        url = settings[result];
                    }
                    if (previousSize !== result) {
                        setSource();
                    }
                    previousSize = result;
                }

                win.on('resize.imageSource' + directiveId, getUrl);
                getUrl();
            }
            $timeout(function () {
                checkPosition();
            });

            $attrs.$observe("imageSourceModel", function (value) {
                if (!value) return;

                deferred.resolve();
                url = value;
                setSource();
            });
        }

        $scope.$on('$destroy', function () {
            win.off('resize.imageSource' + directiveId);
            scroller.off('scroll.imageSource' + directiveId);
            $element.off('transitionend.imageSource');
            cancelListener();
        });
    }
};